module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s( /** top header */ ) + "\n  "), _c('div', {
    staticClass: "t-header",
    attrs: {
      "id": "main-header-top"
    }
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.isLogin) ? _c('a', {
    staticClass: "link-text m-r",
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    staticClass: "link-text m-r",
    attrs: {
      "href": "#/register"
    }
  }, [_vm._v("注册")]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('a', {
    staticClass: "link-text m-r telephone",
    on: {
      "click": function($event) {
        return _vm.showPanel()
      }
    }
  }, [_vm._v(_vm._s(_vm.telephone))]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('a', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "margin-right": "23px"
    },
    on: {
      "click": function($event) {
        return _vm.showPanel()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPanel) ? _c('div', {
    staticClass: "panel text-center"
  }, [_c('a', {
    staticClass: "gray-4",
    attrs: {
      "href": "#/collect"
    },
    on: {
      "click": function($event) {
        return _vm.showPanel()
      }
    }
  }, [_vm._v("我的收藏")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "gray-4",
    attrs: {
      "href": "#/order/list/"
    },
    on: {
      "click": function($event) {
        return _vm.showPanel()
      }
    }
  }, [_vm._v("我的订单")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "gray-4",
    attrs: {
      "href": "#/forgetpass"
    },
    on: {
      "click": function($event) {
        return _vm.showPanel()
      }
    }
  }, [_vm._v("忘记密码")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "gray-4",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "link-text",
    attrs: {
      "target": "_blank",
      "href": "/admin/#/"
    }
  }, [_vm._v("进入商家中心")])])])]), _vm._v("\n  " + _vm._s( /** search header */ ) + "\n  "), (_vm.hasHeader()) ? _c('div', {
    staticClass: "inner-content search-header m-t-md"
  }, [_c('img', {
    staticClass: "header-img pull-left",
    staticStyle: {
      "width": "12%"
    },
    attrs: {
      "src": "https://cosmolove.oss-cn-beijing.aliyuncs.com/bride/logo_0.png"
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "search-wrp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-box",
    staticStyle: {
      "": ":-ms-clear"
    },
    attrs: {
      "placeholder": "搜索商家、套餐、案例"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchKey.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.keyword !== '') ? _c('i', {
    staticClass: "fa fa-remove search-remove",
    on: {
      "click": _vm.removeKey
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search search-icon",
    on: {
      "click": _vm.searchKey
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-wrp gray-2 search-hint"
  }, [_c('span', [_vm._v("热门搜索：")]), _vm._v(" "), _vm._l((_vm.hotWords), function(item, n) {
    return _c('span', {
      staticStyle: {
        "margin-left": "1rem"
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.clickHotWord(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]) : _vm._e(), _vm._v("\n  " + _vm._s( /** content header */ ) + "\n  "), (_vm.isHomePage()) ? _c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 12,
        stickyTop: 0
      }),
      expression: "{ zIndex: 12, stickyTop: 0 }"
    }]
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "inner-content p-t-md clearfix"
  }, [_c('div', {
    staticClass: "pull-right more-link",
    on: {
      "click": _vm.toList
    }
  }, [_vm._v("更多 "), _c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "categ-div",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "categ",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('home-top-area', 0)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), (_vm.activeDetailTag == 0) ? _c('div', {
    staticClass: "categ-line"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "categ-div",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "categ",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('home-recmd-area', 1)
      }
    }
  }, [_vm._v("特别推荐")]), _vm._v(" "), (_vm.activeDetailTag == 1) ? _c('div', {
    staticClass: "categ-line"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "categ-div",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "categ",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('home-video-area', 2)
      }
    }
  }, [_vm._v("致爱影像")]), _vm._v(" "), (_vm.activeDetailTag == 2) ? _c('div', {
    staticClass: "categ-line"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.categArr), function(item, n) {
    return _c('div', {
      staticClass: "categ-div",
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "categ",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo(("home-categ-area-" + n), 3 + n)
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), (_vm.activeDetailTag == 3 + n) ? _c('div', {
      staticClass: "categ-line"
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "categ-div",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "categ",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('home-info-area', 3 + _vm.categArr.length)
      }
    }
  }, [_vm._v("资讯")]), _vm._v(" "), (_vm.activeDetailTag == 3 + _vm.categArr.length) ? _c('div', {
    staticClass: "categ-line"
  }) : _vm._e()])], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.isHomePage() && _vm.hasHeader() && !_vm.isPayPage()) ? _c('hr', {
    staticClass: "home-hr m-t-md"
  }) : _vm._e(), _vm._v("\n  " + _vm._s( /** content */ ) + "\n  "), _c('router-view'), _vm._v("\n  " + _vm._s( /** footer */ ) + "\n  "), (_vm.hasFooter()) ? _c('div', {
    staticClass: "login-footer login-footer-tp"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.hasCom) ? _c('div', {
    staticClass: "fixed-com",
    staticStyle: {
      "z-index": "13"
    }
  }, [_c('div', {
    staticClass: "com-wrp clearfix"
  }, [_c('div', {
    staticClass: "com-header com-hide"
  }, [_vm._v("在线咨询\n        " + _vm._s( /** close button */ ) + "\n        "), _c('i', {
    staticClass: "pull-right fa fa-times close-icon hidden"
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "com-login pull-right com-item-3 text-center",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/bride_app_login.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com-login-desc"
  }, [_vm._v("\n          登录\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "com-item-3 pull-right text-center com-scroller",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-qr-1 pull-left text-center"
  }, [_c('a', {
    staticClass: "link-text m-r",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  }), _vm._v(" 微信公众号")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/bride_wechat_qrcode.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com-qr-desc"
  }, [_vm._v("\n          微信公众号\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-text m-r",
    attrs: {
      "href": "http://weibo.com/cosmobride",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  }), _vm._v(" 新浪微博")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right text-right"
  }, [_c('div', {
    staticClass: "gray-1"
  }, [_vm._v("时尚新娘客服热线")]), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v("400-900-8520")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("时尚新娘客服热线")]), _vm._v(" "), _c('div', [_vm._v("工作时间：每日09:00-23:00")]), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v("400-900-8520")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("下载手机app")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "footer-qr",
    attrs: {
      "src": require("./assets/bride_app_qrcode.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "http://api.ccbride.com:8080/rest/openIosApp.html"
    }
  }, [_vm._v("立即下载")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-ft"
  }, [_c('a', {
    staticClass: "gray-4",
    attrs: {
      "target": "_blank",
      "href": "#/aboutus/"
    }
  }, [_vm._v("关于时尚")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-ft"
  }, [_vm._v("手机：186-1105-2766")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-ft"
  }, [_vm._v("电话：010-6589-5819")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-ft"
  }, [_vm._v("邮箱：wangxin@cosmo.love")]), _vm._v(" "), _c('div', [_vm._v("地点：北京市朝阳区光华路9号时尚大厦")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-footer login-footer-bt"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#787878"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.miitbeian.gov.cn/"
    }
  }, [_vm._v("京ICP备17048592号")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#787878",
      "margin-left": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "-3px",
      "margin-right": "5px"
    },
    attrs: {
      "src": "https://cosmolove.oss-cn-beijing.aliyuncs.com/bride/national_emblem_icon.jpg"
    }
  }), _vm._v("京公网安备 11010502040704号")]), _vm._v(" "), _c('br'), _vm._v("\n    时尚致爱(北京)文化有限公司 © 2018 Copyright.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-item qq-wrp clearfix",
    staticStyle: {
      "background-color": "#e5e5e5"
    }
  }, [_c('i', {
    staticClass: "fa fa-qq icon-fa"
  }), _vm._v(" "), _c('div', {
    staticClass: "com-content com-hide"
  }, [_c('a', {
    attrs: {
      "href": "tencent://message/?uin=4086724637&Site=&Menu=yes"
    }
  }, [_vm._v("4086724637")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-item com-item-3 com-hide"
  }, [_c('i', {
    staticClass: "fa fa-phone icon-fa"
  }), _vm._v(" "), _c('div', {
    staticClass: "com-content"
  }, [_vm._v("联系电话 "), _c('br'), _vm._v(" 400-900-8520")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "com-qr pull-right com-item-3 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/bride_app_qrcode.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com-qr-desc"
  }, [_vm._v("\n          扫码下载app\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ace119"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 599
// module chunks = 1